module.exports = __webpack_public_path__ + "static/miss-anthropocene-864d736463132cfba1d1d9de6d63625d.png";